export {
  ReplaceByMapOptions,
  ReplaceItemsOptions,
  Inclusion,
  Substraction,
  arrayize,
  asyncMap,
  difference,
  findByKey,
  intersection,
  remove,
  replace,
  uniquify,
  uniquifyByKey
} from '@thalesrc/js-utils/array';
export * from '@thalesrc/js-utils/class';
export * from '@thalesrc/js-utils/function';
export * from '@thalesrc/js-utils/map';
export * from '@thalesrc/js-utils/math';
export { clone, deepest, deepFreeze } from '@thalesrc/js-utils/object';
export * from '@thalesrc/js-utils/promise';
// export {  } from '@thalesrc/js-utils/string';

export * from '@thalesrc/js-utils/compact';
export * from '@thalesrc/js-utils/is-falsy';
export * from '@thalesrc/js-utils/is-truthy';
export * from '@thalesrc/js-utils/open-promise';
export * from '@thalesrc/js-utils/smart-map';
export * from '@thalesrc/js-utils/unique-id';
export * from '@thalesrc/js-utils/limit';
